import { makeLazy } from "lib/make-lazy"

export const HelpContainer = makeLazy(() => import("./inner-help-container"), "InnerHelpContainer")
